import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  size = 'medium', 
  text = 'A carregar...', 
  fullPage = false,
  color = '#00a5b5'
}) => {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 60
  };
  
  const spinnerSize = sizeMap[size] || sizeMap.medium;
  
  const spinner = (
    <div className={`loading-spinner-container ${fullPage ? 'full-page' : ''}`} data-testid="loading-spinner">
      <div 
        className="loading-spinner"
        style={{
          width: spinnerSize,
          height: spinnerSize,
          borderColor: `${color}20`,
          borderTopColor: color
        }}
      />
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
  
  return spinner;
};

export default LoadingSpinner;
